import React from 'react';
import styled from 'styled-components';
import {Link} from 'react-router-dom';

import "./m_home.css"

import MFoot from '../../../components/MFooter';
import MNAVBar from '../../../components/MHeader';
import {Chuva} from "../../../components/EfeitosChuva";

import IconMicroprocess from '../../../assets/img/dj-icons/microprocessador.svg';
import IconRobo from '../../../assets/img/dj-icons/robotica.svg';
import IconProgramacao from '../../../assets/img/dj-icons/programacao.svg';

import IconeLogin from './IconeLogin.svg';
import IconeCadastrar from './IconeCadastrar.svg';

function App() {
	return (
        <div id='MHomeDj' className="container-center-horizontal">
            <div className="m-homescreen">
				<Chuva/>
                <MNAVBar/>
                <MHome/>
                <MFoot/>
            </div>
        </div>
    );
}

export default App;


function MHome(){
    // const {  } = props;
    const TopGroup = styled.div`
        padding:80px 14px 0;
        display:flex;
        align-items: center;
        justify-content: center;
        flex-wrap: nowrap;
        flex-direction: column
    `;
    const Rectangle = styled.div`
		position: absolute;
		z-index: -1;
    	width: 100%;
    	height: 361px;
    	top: 0;
    	background-color: var(--azulinovafundo);
    `;
    const InovOnlineSub = styled.span`
        padding-top: 15px;
		height: 66px;
        font-family: Poppins;
        font-style: normal;
        font-weight: 500;
        font-size: 22px;
        line-height: 33px;

        color: #F2F2F2;

		display: flex;
    	align-items: center;
    `;
	const TextoNW = styled.span`
			white-space: nowrap;
	`;
	const P2 = styled.p`
		padding:16px 0 10px;
		font-family: Poppins;
		font-style: normal;
		font-weight: 500;
		font-size: 20px;
		line-height: 30px;

		/* identical to box height */
		text-align: center;

		color: #F2F2F2;
	`

	const  Saudacao = styled.div`

		max-width: 511px;

		width: 100%;
		height: 60px;

		font-family: Poppins;
		font-style: normal;
		font-weight: normal;
		font-size: 20px;
		line-height: 30px;
		/* or 150% */

		/* cor fundo rank */
		color: #1D1D1F;
		margin: 0 auto;
		margin-top: 12px;
		padding-left: 15px;
    	margin-bottom: 8px;

		span {
			font-weight: 600;
		}
	`;
    return (
	    <div className='MHome'>
				<Rectangle/>
				<TopGroup>
					<InovOnline/>
					<InovOnlineSub>
						<p>{"Plataforma do online do "}
							<TextoNW>
								{"Maratoninha Maker "}
								{CoreDj}
							</TextoNW></p>
					</InovOnlineSub>
				</TopGroup>

				<P2>Aqui vamos aprender sobre:</P2>
				<Cards/>

				<Saudacao>
					<p>Seja bem-vindo.</p>
					<span>O que deseja fazer?</span>
				</Saudacao>
				<Btns/>
	    </div>
		);
}

function Btns(){
	const BtnsConteiner = styled.div`
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-items: center;
		justify-content: space-evenly;


	`;
	const BtnsConteinerConstraints = styled.div`
		@media (min-width:400px) {
			max-width: 40vw;
			max-width: 500px;
			margin: 0;
			margin-left: auto;
			margin-bottom: 10px;
		}
	`;
	const Btn = styled.div`
		width: 150px;
		height: 105px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		/* m-card */
		box-shadow: 4px 2px 6px 1px rgba(0, 0, 0, 0.25);
		filter: drop-shadow(1px 4px 4px rgba(0, 0, 0, 0.25));

		background-color: ${props=>props.cor};
		border-radius: 8px;

	`;
	const BtnTexto = styled.span`
		font-family: Archivo, Poppins;
		font-style: normal;
		font-weight: bold;
		font-size: 25px;
		line-height: 27px;

		text-align: center;
		color: #FFFFFF;
		padding-top:10px;

	`;
	const BtnIcone = styled.div`
	  background: url(${props=>props.src});
	  width: 28px;
	  height: 28px;
	`;
	return (
		<BtnsConteinerConstraints>
			<BtnsConteiner>
				<Link to={'/Login'} className='djbtn'>
					<Btn cor="#9B51E0">
						<BtnIcone src={IconeLogin}/>
						<BtnTexto>Entrar</BtnTexto>
					</Btn>
				</Link>
				<Link to={'/Cadastrar'} className='djbtn'>
					<Btn cor="#F0AB5B">
						<BtnIcone src={IconeCadastrar}/>
						<BtnTexto>Cadastrar</BtnTexto>
					</Btn>
				</Link>
			</BtnsConteiner>
		</BtnsConteinerConstraints>
	);
};

function Cards(){
	const Card1 = styled.div`

		width: 28%;
		max-width: 115px;
		height: 100px;
		background-color: #54C0EB;
		border-radius: 8px;
		box-shadow: 4px 2px 6px #00000040, 1px 4px 4px #00000040;

	`;
	/*&.animate-enter4 {
		animation: go-back 1s 0s 3 normal forwards;
		animation: xxx 1s infinite  0s 10 normal forwards;
		opacity: 1;
		transform: translate(-25px, 0);
	}
	@keyframes go-back {
	  from {
		transform: translateX(100px);
	  }
	  to {
		transform: translateX(0);
	  }
	}*/
	const Card2 = styled.div`
		width: 115px;
		height: 100px;
		background-color: #FFBE31;
		border-radius: 8px;
		box-shadow: 4px 2px 6px #00000040, 1px 4px 4px #00000040;

		&.animate-enter5 {
			animation: animate-enter5-frames 0.4s ease-in-out 0.1s 1 normal forwards;
			opacity: 0;
			transform: translate(25px, 0);
		}
	`;
	const Card3 = styled.div`
		width: 28%;
		max-width: 115px;
		height: 100px;
		background-color: #9871F5;
		border-radius: 8px;
		box-shadow: 4px 2px 6px #00000040, 1px 4px 4px #00000040;

		&.animate-enter6 {
			animation: animate-enter6-frames 0.6s ease-in-out 0.3s 1 normal forwards;
			opacity: 0;
			transform: translate(0, 25px);
		}
	`;
	const CardsConteiner = styled.div`
		display: flex;
		flex-wrap: nowrap;
	    flex-direction: row;
	    align-items: center;
	    justify-content: space-around;
	    justify-content: space-evenly;
		margin-bottom: -25px;
		max-width: 450px;
		margin: 0 auto;
		div {
			display: flex;
			flex-wrap: nowrap;
		    flex-direction: column;
		    align-items: center;
			justify-content: center;
		}
		.m-card {
			margin-left: 3px;
		}
		div p {
			font-family: Poppins;
			font-style: normal;
			font-weight: normal;
			font-size: 15px;
			line-height: 20px;

			/* identical to box height, or 133% */
			text-align: center;

			/* Branco */
			color: #FFFFFF;
			padding-top: 3px;
		};
		div div{
			width: 60px;
			height: 60px;
			background-repeat: no-repeat;
            background-size: contain;
		};
	`;
	const Robo = styled.div`background-image: url(${IconRobo})`
	const Code = styled.div`background-image: url(${IconProgramacao})`
	const Chip = styled.div`background-image: url(${IconMicroprocess})`
	return (
		<CardsConteiner>
			<Card1 className='m-card animate-enter4'>
				<Robo/>
				<p>Robótica</p>
			</Card1>
			<Card2 className='m-card'>
				<Code/>
				<p>Programação</p>
			</Card2>
			<Card3 className='m-card'>
				<Chip/>
				<p>Eletrônica</p>
			</Card3>
		</CardsConteiner>
	)
}

function InovOnline(){
    const LogoPlataforma = styled.span`
        font-family: Lobster;
        font-style: normal;
        font-weight: normal;
        font-size: 77px;
        ${'' /* line-height: 40px; */}

        /* or 52% */
        ${'' /* display: flex;
        align-items: center;
        text-align: center; */}

        /* Branco */
        color: #FFFFFF
    `
    return (<LogoPlataforma>
        {"InovOnline"}
    </LogoPlataforma>)
}



const CoreDj =(
	<svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M19.5384 5.20741C19.5384 2.33141 17.1347 -1.52588e-05 14.1701 -1.52588e-05C12.3703 -1.52588e-05 10.7821 0.861732 9.80767 2.17889C8.83323 0.861732 7.24509 -1.52588e-05 5.44583 -1.52588e-05C2.48063 -1.52588e-05 0.0769043 2.33087 0.0769043 5.20741C0.0769043 5.61479 0.130224 6.00952 0.221629 6.39C0.96701 10.8824 6.11667 15.6217 9.80767 16.9231C13.4981 15.6217 18.6484 10.8824 19.3926 6.39053C19.4851 6.01006 19.5384 5.61533 19.5384 5.20741Z" fill="#E4AD1E"/>
	</svg>
)
